var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize:throttle.10",value:(_vm.getDimensions),expression:"getDimensions",arg:"throttle",modifiers:{"10":true}}],staticClass:"canvasWrapper"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }